import { Component } from '@angular/core';
import { Question } from '@models/votes/question.entity';
import { Vote } from '@models/votes/vote.entity';
import { AccountService } from '@services/account.service';
import { AuthorizationService } from '@services/authorization.service';
import { MessageService } from '@services/message.service';
import { QuestionService } from '@services/question.service';
import { clone } from '@utils/clone.function';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { catchError } from 'rxjs';

@Component({
  selector: 'ebs-vote',
  templateUrl: './vote.component.html',
  styleUrls: ['./vote.component.scss'],
})
export class VoteComponent {
  public loaded: boolean = false;

  public questions: Question[] = [];
  public selectedQuestion: Question | null = null;
  public selectedVotes: Vote[] = [];

  public isVoteVisible: boolean = false;

  public get whiteSelected(): boolean {
    return this.selectedVotes.findIndex((elem) => elem.isWhite) > -1;
  }

  constructor(
    private questionService: QuestionService,
    private authService: AuthorizationService,
    private accountService: AccountService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {
    this.loadQuestions();
  }

  loadQuestions() {
    this.questionService.getVoteList().subscribe((result: Question[]) => {
      this.questions = result;
      this.questions.forEach((elem) => {
        if (elem.possibleVotes.findIndex((vote) => vote.isWhite) > -1) {
          elem['hasWhite'] = true;
        }
      });
      this.loaded = true;
    });
  }

  editQuestion(question: Question | null) {
    this.selectedQuestion = clone(question);
  }

  modifyQuestion(index: number) {
    this.saveGroupChanges(this.questions[index]);
  }

  saveGroupChanges(question: Question) {
    this.questionService
      .modifyQuestion([question])
      .pipe(
        catchError((err) => {
          this.loadQuestions();
          this.selectedQuestion = null;
          this.messageService.error(
            'Modifica voto',
            'Errore durante la modifica',
          );
          return err;
        }),
      )
      .subscribe((res) => {
        this.loadQuestions();
        this.selectedQuestion = null;
        this.messageService.success(
          'Modifica voto',
          'Modifica avvenuta con successo',
        );
      });
  }

  removeQuestion(question: Question, index: number) {
    this.questionService
      .remveQuestion([question])
      .pipe(
        catchError((err) => {
          this.selectedQuestion = null;
          this.messageService.error(
            'Eliminazione voto',
            "Errore durante l'eliminazione",
          );
          return err;
        }),
      )
      .subscribe((res) => {
        this.questions.splice(index, 1);
        this.selectedQuestion = null;
        this.messageService.success(
          'Eliminazione voto',
          'Eliminazione avvenuta con successo',
        );
      });
  }

  showVotes(question: Question) {
    this.isVoteVisible = true;
    this.selectedQuestion = question;
    this.questionService
      .getEncryptedVote(question.questionId || -1)
      .pipe(
        catchError((err, caught) => {
          this.selectedQuestion = null;
          this.selectedVotes = [];
          this.messageService.error(
            'Visione voto',
            'Errore durante la visualizzazione',
          );
          return caught;
        }),
      )
      .subscribe((res) => {
        if (this.selectedQuestion !== null) {
          this.selectedQuestion.answers = res;
        }
      });
  }

  voteChanged() {
    if (this.whiteSelected) {
      this.selectedVotes = this.selectedVotes.filter((elem) => elem.isWhite);
    }
  }

  isDisabled(vote: Vote) {
    return (
      (this.whiteSelected && !vote.isWhite) ||
      (this.selectedQuestion?.maxResponses === this.selectedVotes.length &&
        this.selectedVotes.findIndex((elem) => elem.voteId === vote.voteId) ===
          -1)
    );
  }

  voteNow(question: Question) {
    this.selectedQuestion = question;
    this.confirmationService.confirm({
      accept: () => {
        this.confirm();
      },
      reject: () => {
        this.cancel();
      },
    });
  }

  confirm() {
    let questId = this.selectedQuestion?.questionId || -1;
    this.questionService
      .sendVote(
        questId,
        Array.isArray(this.selectedVotes)
          ? this.selectedVotes
          : [this.selectedVotes],
      )
      .pipe(
        catchError((err) => {
          this.selectedQuestion = null;
          this.selectedVotes = [];
          this.messageService.error(
            'Aggiunta voto',
            'Errore durante la votazione',
          );
          return err;
        }),
      )
      .subscribe((res) => {
        this.selectedQuestion = null;
        this.selectedVotes = [];
        this.loadQuestions();
        this.messageService.success(
          'Aggiunta voto',
          'Votazione registrata con successo',
        );
      });
  }

  cancel() {
    this.messageService.warn('Aggiunta voto', 'Voto non effettuato');
    this.selectedQuestion = null;
  }
}
